(() => {
  'use strict';

  const routesRoot = window.Shopify?.routes?.root || '/';
  const locale = (document.documentElement.lang || 'nl').toLowerCase().split('-')[0];
  const translations = {
    nl: {
      index: 'Op deze pagina',
      helpLabel: 'Contact over dit document',
      helpTitle: 'Heb je een vraag over dit document?',
      helpText: 'We leggen onze afspraken graag duidelijk uit. Neem contact op met het ZinVolt-team wanneer iets niet helder is.',
      contact: 'Neem contact op'
    },
    en: {
      index: 'On this page',
      helpLabel: 'Contact about this document',
      helpTitle: 'Do you have a question about this document?',
      helpText: 'We are happy to explain our agreements clearly. Contact the ZinVolt team if anything is unclear.',
      contact: 'Contact us'
    },
    fr: {
      index: 'Sur cette page',
      helpLabel: 'Contact au sujet de ce document',
      helpTitle: 'Vous avez une question sur ce document ?',
      helpText: "Nous expliquons volontiers nos accords clairement. Contactez l'équipe ZinVolt si un point n'est pas clair.",
      contact: 'Nous contacter'
    }
  };
  const labels = translations[locale] || translations.nl;

  const slugify = (value) => {
    return value
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'onderdeel';
  };

  const uniqueId = (base, usedIds) => {
    let id = base;
    let index = 2;

    while (usedIds.has(id) || document.getElementById(id)) {
      id = `${base}-${index}`;
      index += 1;
    }

    usedIds.add(id);
    return id;
  };

  const createIndex = (content) => {
    if (content.querySelector('.zv-legal-index')) return;

    const headings = Array.from(content.querySelectorAll('h2'))
      .filter((heading) => heading.textContent.trim().length > 0)
      .slice(0, 12);

    if (headings.length < 2) return;

    const usedIds = new Set();
    const nav = document.createElement('nav');
    nav.className = 'zv-legal-index';
    nav.setAttribute('aria-label', labels.index);

    const title = document.createElement('p');
    title.className = 'zv-legal-index__title';
    title.textContent = labels.index;

    const links = document.createElement('div');
    links.className = 'zv-legal-index__links';

    headings.forEach((heading) => {
      if (!heading.id) {
        heading.id = uniqueId(slugify(heading.textContent.trim()), usedIds);
      }

      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      links.appendChild(link);
    });

    nav.append(title, links);
    content.insertBefore(nav, content.firstChild);
  };

  const createHelpBlock = (container) => {
    if (container.querySelector('.zv-legal-help')) return;

    const help = document.createElement('aside');
    help.className = 'zv-legal-help';
    help.setAttribute('aria-label', labels.helpLabel);
    help.innerHTML = `
      <h2>${labels.helpTitle}</h2>
      <p>${labels.helpText}</p>
      <a class="zv-legal-help__button zv-btn zv-btn--primary" href="${routesRoot}pages/contact">
        ${labels.contact}
        <svg class="zv-icon zv-icon--arrow-right" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m8 4 8 8-8 8" stroke-width="3"></path></svg>
      </a>
    `;

    container.appendChild(help);
  };

  const enhance = () => {
    const policyBody = document.querySelector('.shopify-policy__body');
    const customContent = document.querySelector('[data-zv-legal-content]');
    const content = customContent || policyBody?.querySelector('.rte') || policyBody;
    const card = customContent?.closest('.zv-legal-card') || policyBody;

    if (!content || !card) return;

    content.classList.add('zv-legal-content');
    createIndex(content);
    createHelpBlock(card);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance, { once: true });
  } else {
    enhance();
  }

  document.addEventListener('shopify:section:load', enhance);
})();
